import React from 'react'

interface OriginalPriceProps {
  children: React.ReactNode;
}

export function OriginalPrice ({ children }: OriginalPriceProps) {
  return (
    <span>
      <span className='sr-only'>Original price: </span>
      <span className='line-through body text-gray-500'>{children}</span>
    </span>
  )
}

OriginalPrice.displayName = 'MarketplaceCard.OriginalPrice'
